// knowledge/142: the External section's channels, per host I reach as an external. Held here,
// not in ExternalSection, so leaving one from anywhere (the details dialog too) drops its row.
import type { Channel } from "$lib/core/types.js";

export const externalChannels: Record<string, Channel[]> = $state({});

export function dropExternalChannel(workspaceId: string, channelId: string): void {
  const list = externalChannels[workspaceId];
  if (list) externalChannels[workspaceId] = list.filter((c) => c.id !== channelId);
}
